import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Link, Redirect } from "react-router-dom";
import * as resourceTypes from "../constants/resourceTypes";
import isEmpty from "lodash/isEmpty";
import FeatureComponent from "./features/Features";
import DetailComponent from "./features/Details";
import EducationComponent from "./features/Education";
import Pagination from "./Pagination";
import * as Resources from "../constants/resources";
import App from "./App.css";

const INITIAL_STATE = {
  selectedCategory: "",
  selectedSubCategory: "",
  categoryData: "",
  mobileSideBar: false
};

const getSubCategoryResources = (category, subCategory, subcatType) => {
  return Resources[category]
    .filter(data => subCategory.trim() === data.title.trim())[0]
    .data.filter(data => subcatType.trim() === data.title.trim());
};

const getResourceSubCatData = (category, subCatTitle) => {
  return Resources[category].filter(data => subCatTitle.trim() === data.title.trim());
};

const getResourceSubCatRoute = (category, subCategory, page) =>
  `/categories/${category}/sub/${subCategory}?page=${page}`;

const getSubCatResourcesRoute = (category, subCat, subCatGroup, page) =>
  `/categories/${category}/sub/${subCat}/sub/${subCatGroup}?page=${page}`;

class SidebarMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE
    };
  }
  handleSubCatChange = (category, subCategory, data) => {
    console.log("Here", category, subCategory, data);
    this.setState({ subCategoryData: "" });
    this.setState({ selectedSubCategory: subCategory });
    this.setState({ selectedCategory: category });
    this.setState({
      categoryData: data.filter(subCat => subCat.title === subCategory)
    });

    // this.props.history.push(`/categories/${category}/sub/${subCategory}`);
    this.props.history.push(getResourceSubCatRoute(category, subCategory, 1));
  };

  handleChildClick(event, title) {
    let detailTopic = title;
    this.setState({
      subCategoryData: this.state.categoryData[0].data.filter(
        subCat => subCat.title === detailTopic
      )
    });
  }

  render() {
    const showSubCategories = (resourceType, resourceContent) => {
      console.log("here");
      return (
        <ul className="list-group">
          {isEmpty(resourceContent) ? (
            <span />
          ) : (
            resourceContent.map((subCategory, index) => (
              <li key={index} className="list-group-item">
                <div className="form-check">
                  <label className="form-check-label">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="optradio"
                      value={subCategory.title}
                      onChange={e =>
                        this.handleSubCatChange(resourceType, e.target.value, resourceContent)
                      }
                    />
                    <span>{subCategory.title}</span>
                  </label>
                </div>
              </li>
            ))
          )}
        </ul>
      );
    };

    return (
      <React.Fragment>
        <div className="contentCards">
          <Switch>
            <Route
              exact
              path="/"
              render={() => (
                <Redirect to={getResourceSubCatRoute("entrepreneurship", "Entrepreneurship", 1)} />
              )}
            />

            <Route
              exact
              path="/categories/:category/sub/:subCat"
              render={props => (
                <React.Fragment>
                  {console.log("Hello ", props.match.params.subCat, props.match.params.category)}

                  <div className="careerHeading">
                    <h4>{props.match.params.subCat}</h4>
                  </div>

                  <FeatureComponent
                    data={getResourceSubCatData(
                      props.match.params.category,
                      props.match.params.subCat
                    )}
                    page={new URLSearchParams(props.location.search).get("page")}
                    onClick1={(e, subCategory) =>
                      this.props.history.push(
                        `/categories/${props.match.params.category}/sub/${
                          props.match.params.subCat
                        }/sub/${subCategory}`
                      )
                    }
                    onClick={(e, subCategory) =>
                      this.props.history.push(
                        getSubCatResourcesRoute(
                          props.match.params.category,
                          props.match.params.subCat,
                          subCategory,
                          1
                        )
                      )
                    }
                  />
                  <Pagination
                    numberOfPages={Math.ceil(
                      getResourceSubCatData(
                        props.match.params.category,
                        props.match.params.subCat
                      )[0].data.length / 16
                    )}
                    currentPage={new URLSearchParams(props.location.search).get("page")}
                    route={getResourceSubCatRoute(
                      props.match.params.category,
                      props.match.params.subCat,
                      ""
                    )}
                  />
                </React.Fragment>
              )}
            />
            <Route
              exact
              path="/categories/:category/sub/:subCat/sub/:res"
              render={props => (
                <React.Fragment>
                  <div className="careerHeading">
                    <h4>
                      <Link
                        to={`/categories/${props.match.params.category}/sub/${
                          props.match.params.subCat
                        }`}
                      >
                        {props.match.params.subCat}
                      </Link>{" "}
                      / {props.match.params.res}
                    </h4>
                  </div>

                  {
                    <React.Fragment>
                      {props.match.params.category === resourceTypes.EDUCATION ? (
                        <EducationComponent
                          data={getSubCategoryResources(
                            props.match.params.category,
                            props.match.params.subCat,
                            props.match.params.res
                          )}
                        />
                      ) : (
                        <React.Fragment>
                          <DetailComponent
                            data={getSubCategoryResources(
                              props.match.params.category,
                              props.match.params.subCat,
                              props.match.params.res
                            )}
                            page={new URLSearchParams(props.location.search).get("page")}
                          />
                          <Pagination
                            numberOfPages={Math.ceil(
                              getSubCategoryResources(
                                props.match.params.category,
                                props.match.params.subCat,
                                props.match.params.res
                              )[0].data.length / 8
                            )}
                            currentPage={new URLSearchParams(props.location.search).get("page")}
                            route={getSubCatResourcesRoute(
                              props.match.params.category,
                              props.match.params.subCat,
                              props.match.params.res,
                              ""
                            )}
                          />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  }
                </React.Fragment>
              )}
            />
          </Switch>
        </div>
        <div className="sideBar">
          <div className="card side-card">
            <div className="card-body">
              <div className="row">
                <div className="col-sm">
                  <h6 className="card-title">CATEGORIES</h6>
                </div>
              </div>
              <ul className="list-group list-group-flush">
                <div id="accordion">
                  <li className="list-group-item">
                    <button
                      data-toggle="collapse"
                      data-target="#selfImprovement"
                      aria-expanded="false"
                      aria-controls="selfImprovement"
                      className="btn btn-sidebar-category"
                    >
                      <span>
                        Self-Improvement
                        <i className="fa" />
                      </span>
                    </button>

                    <div
                      id="selfImprovement"
                      className="collapse"
                      aria-labelledby="headingSelfImprovement"
                      data-parent="#accordion"
                    >
                      {showSubCategories(
                        resourceTypes.SELF_IMPROVEMENT,
                        this.props.selfimprovement
                      )}
                    </div>
                  </li>

                  <li className="list-group-item">
                    <button
                      data-toggle="collapse"
                      data-target="#entrepreneurship"
                      aria-expanded="false"
                      aria-controls="entrepreneurship"
                      className="btn btn-sidebar-category"
                    >
                      <span>
                        Entrepreneurship
                        <i className="fa" />
                      </span>
                    </button>

                    <div
                      id="entrepreneurship"
                      className="collapse"
                      aria-labelledby="headingEntrepreneurship"
                      data-parent="#accordion"
                    >
                      {showSubCategories(
                        resourceTypes.ENTREPRENEURSHIP,
                        this.props.entrepreneurship
                      )}
                    </div>
                  </li>

                  <li className="list-group-item">
                    <button
                      data-toggle="collapse"
                      data-target="#education"
                      aria-expanded="false"
                      aria-controls="education"
                      className="btn btn-sidebar-category"
                    >
                      <span>
                        Education
                        <i className="fa" />
                      </span>
                    </button>
                    <div
                      id="education"
                      className="collapse"
                      aria-labelledby="headingEducation"
                      data-parent="#accordion"
                    >
                      {showSubCategories(resourceTypes.EDUCATION, this.props.education)}
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SidebarMenu;



// WEBPACK FOOTER //
// ./src/components/SidebarMenu.js